export default __webpack_public_path__ + "static/media/report_overall_icon.18d283de.svg";